export default {
  errorsRootKey: 'sms/masiv',
  resource: 'sms/massiv',
  actions: ['index', 'create', 'show', 'update', 'destroy'],

  configByAccount(customerId, params = {}, options = {}) {
    return Vue.http.get(
      `sms/massiv/getSettingbyCustomer/${customerId}`,
      {params, ...options}
    ).then(response => response.data)
  },

  testSMSLinkMobility(data = {}, options = {}) {
    return Vue.http.post(
      'sms/massiv/test',
      data
    ).then(response => response.data)
  }
}
